// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"67":"374d2591","95":"b0d937e4","533":"2892d70a"}[chunkId] + ".js";
};